<template>
  <RestaurantRequestsForm :typeEndPoint="'restauranCategoriesShow'" :dataParams="this.$route.params" />
</template>
<script>
import RestaurantRequestsForm from '@/components/modules/restaurant/categories/form'
export default {
  name: 'RestaurantRequestsEdit',
  components: {
    RestaurantRequestsForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/categories/edit.vue